import { Injectable } from '@angular/core';

@Injectable()
export class StringVariable {
  public email: any = 'Email';
  public country: any = 'Country';
  public countryMobileNo: any = 'Country Code';
  public mobileNumber: any = 'Mobile Number';
  public grabberName: any = 'GrabberName';
  public name: any = 'Name';
  public adminId: any = 'Admin Id';
  public customerId: any = 'Customer';
  public countryOfficialName: any = 'Country Official Name';
  public countryAlpha2: any = 'Country Alpha  2';
  public countryAlpha3: any = 'Country Alpha 3';
  public code: any = 'Code';
  public affiliatePartner: any = 'Affiliate Partner';
  public city: any = 'City';
  public pincode: any = 'Pincode';
  public accessRoleId = 'Access Role ID';
  public Description = 'Description';

  public password: any = 'Password';
  public newPassword: any = 'New Password';
  public currentPassword: any = 'Current Password';
  public changePassword: string = 'Change Password';

  public authenticationApps: any = 'Authentication Apps';
  public twoFactorLabel: any = 'Two Factor';
  public verify: any = 'Verify';
  public mobileAndEmailVerification: any = 'Mobile And Email Verification';
  public otpDeliveryChannel: any = 'OTP Delivery Channel';

  public enableTwoFactorAuth: any = 'Enable Two Factor Auth';
  public enableTrustedDeviceCheck: any = 'Enable Trusted Device Check';

  public description: any = 'Description';
  public documentCategories: any = 'Document Categories';
  public stakeHolderDocumentCategory: any = 'Stake Holder Document Category';
  public actionAfterExpiry: any = 'Action After Expiry';
  public expiryWarningBufferDays: any = 'Expiry Warning Buffer Days';
  public expirable: any = 'Expirable';
  public categoryName: any = 'Category Name';
  public stakeHoldersIdText: any = 'Stake Holders';
  public serviceable: any = 'Serviceable';
  public businessStakeHoldersId: any =
    'Business Stake Holders / UBOs Identifier text';
  public otpSender: any = 'OTP Sender Implementation';
  public addressSchema: any = 'Address Schema';
  public createdDate: any = 'Created Date';
  public businessIdentificationFieldSchema: any =
    'Business Identification Field Schema';
  public individualIdentifierFieldSchema: any =
    'Individual Identification Field Schema';
  public adminFieldSchema: any = 'Admin Field Schema';
  public partnerFieldSchema: any = 'Partner Field Schema';
  public customerFieldSchema: any = 'Customer Field Schema';
  public paymentDetailsFieldSchema: any = 'Payment Details Field Schema';
  public partnerProcessorImpl: any = 'Partner Processor Impl';

  public adminKyc: any = 'Admin KYC';
  public partnerKyc: any = 'Partner KYC';
  public customerKyc: any = 'Customer KYC';
  public affiliatePartnerKyc: any = 'Affiliate Partner KYC';
  public riskScoreForAdmins: string = 'Risk Score of country For Admins';
  public riskScore: string = 'Risk Score';

  public mandatory: any = 'Mandatory';
  public fieldName: any = 'Field Name';
  public fieldType: any = 'Field Type';
  public fieldRegex: any = 'Field Regex';
  public order: any = 'Order';
  public fieldDescription: any = 'Field Description';
  public fieldHint: any = 'Field Hint';
  public selectOptions: any = 'Select Options';
  public selectOptionValue: any = 'Select Option Value';
  public selectOptionDescription: any = 'Select Option Description';
  public hasToBeUnique: any = 'HasTo Be Unique';
  public postalCode: any = 'Postal Code';
  public cityOrTown: any = 'City Or Town';
  public fieldSchemaFieldSelectOptionType: any =
    'Field Schema Field Select Option Type';
  public cmplxFldOrientation: any = 'Complex Field Orientation';
  public mask: any = 'Mask';
  public selectQuery: any = 'Select Query';
  public exQuery: any =
    "select * from execute_global_field_queries('select isd_code::text, known_name::text from countries limit 50') 1st Param - Value, 2nd Param - Description";
  public areaWghtOnCmplxFld: any = 'Area Weight On Complex Field';
  public repeatMinTimes: any = 'Repeat Min Times';
  public expiryAfterDays: any = 'Expiry After Days';
  public expiryDateField: any = 'Expiry Date';
  public toDate: any = 'To Date';
  public fromDate: any = 'From Date';
  public date: any = 'Date';

  public queryString: any = 'Search';
  public expiryType: any = 'Expiry Type';
  public partnerType: any = 'Partner Type';
  public managedBy: any = 'Managed By';
  public createUnderAdmin: any = 'Create Under Admin';
  public status: any = 'Status';
  public customerProfileType: any = 'Customer Profile Type';
  public adminUserId: any = 'Admin User Id';

  public fromCurrencyCode: any = 'From Currency Code';
  public toCurrencyCode: any = 'To Currency Code';
  public Currency: any = 'Currency';

  public documentStatus: any = 'Document Status';
  public userType: any = 'User Type';
  public user: any = 'User';
  public documentCategory: any = 'Document Category';
  public dateRangeType: any = 'Date Range Type';
  public comment: any = 'Comment';

  public alreadyHaveAnOtp: any = 'Already Have An Otp';
  public sendOtp: any = 'Send Otp';
  public resendbtn: any = 'Resend';
  public buttonLogout: any = 'Logout';
  public donebtn: any = 'Done';
  public submitBtn: any = 'Submit';
  public updateBtn: any = 'Update';
  public action: any = 'Action';
  public filterbtn: any = 'Filter';

  public accessControl: any = 'Access Control';
  public method: any = 'Method';
  public httpMethod: any = 'Http Method';

  public adminCode: any = 'Admin Code';
  public implClass: any = 'Impl Class';
  public currencies: any = 'Currencies';
  public currenciesISO3: any = 'Currencies';
  public countriesISO3: any = 'Countries';
  public countries: any = 'Countries';
  public modeOfPayment: any = 'Mode Of Payment';
  public reqPerMinute: any = 'Req Per Minute';
  public partialRefundAllowed: any = 'Partial Refund Allowed';
  public perTransactionValLimitRequest: any =
    'Per Transaction Value Limit Request';
  public admin: any = 'Admin';
  public isActiveRequired: any = 'Is Required Active';
  public paymentInstrumentCode = 'Payment Instrument Code';
  public relationship = 'Relationship';

  public apiKeyUsed = 'Api Key Used';
  public tokenTire = 'Token Tire';
  public successful = 'Successful';
  public api = 'Api';
  public settings: string = 'Profile';

  public partner: any = 'Partner';
  public paymentInstrument: any = 'Payment Instrument';
  public partnerQueryString: any = 'Partner';

  public amount: any = 'Amount';

  public accessRole: any = 'Access Role';
  public type: any = 'Type';
  public emailsToNotify: any = 'Emails To Notify';
  public notifyAllUser: any = 'Notify All User';
  public notifyViaEmail: any = 'Notify Via Email';
  public notifyViaNotification: any = 'Notify Via Notification';
  public userTargetedNotification: any = 'User Targeted Notification';
  public notifyViaEmailIfNotReadWithInMinutes: any =
    'Notify Via Email If Not Read With In Minutes';
  public propagateReadStatusAcrossRelatedNotification: any =
    'Propagate Read Status Across Related Notification';
  public propagateNotificationToUpperLevelIfNotRead: any =
    'Propagate Notification To Upper Level If Not Read';
  public thresholdMinutesToReadNotification: any =
    'Threshold Minutes To Read Notification';
  public notificationBannerType: any = 'Notification Banner Type';
  public notificationBannerDestination: any = 'Notification Banner Destination';
  public thresholdDaysToTransformToBanner: any =
    'Threshold Days To Transform To Banner';

  public PaymentDetailsSchema = 'Payment Details Schema';
  public modeOfPaymentOrPayout = 'Mode of Payment';
  public label = 'label';
  public profile: string = 'Profile';
  public livenessAndSanctionCheckSettings: string =
    'Liveness And Sanction Check Settings';
  public livenessSanctionCheckAdmin: string =
    'Liveness and Sanction Check Admin';
  public livenessSanctionCheckPartner: string =
    'Liveness and Sanction Check Partner';
  public livenessSanctionCheckCustomer: string =
    'Liveness and Sanction Check Customer';
  public updateTheme: string = 'Update Theme';
  public lcTimeBoundCriteria: string = 'Liveness Check Time Bound Criteria';
  public lcTimeBoundCriteriaUnit: string =
    'Liveness Check Time Bound Criteria Unit';
  public lcTimeBoundCriteriaValue: string =
    'Liveness Check Time Bound Criteria Value';
  public lcFrequencyBoundCriteria: string =
    'Liveness Check Frequency Bound Criteria';
  public lcFrequencyBoundCriteriaValue: string =
    'Liveness Check Frequency Bound Criteria Value';
  public scTimeBoundCriteria: string = 'Sanction Check Time Bound Criteria';
  public scTimeBoundCriteriaUnit: string =
    'Sanction Check Time Bound Criteria Unit';
  public scTimeBoundCriteriaValue: string =
    'Sanction Check Time Bound Criteria Value';
  public scTimeBoundCriteriaValueType: string =
    'Sanction Check Time Bound Criteria Value Type';
  public scFrequencyBoundCriteria: string =
    'Sanction Check Frequency Bound Criteria';
  public scFrequencyBoundCriteriaValue: string =
    'Sanction Check Frequency Bound Criteria Value';
  public scFrequencyBoundCriteriaValueType: string =
    'Sanction Check Frequency Bound Criteria Value Type';
  public liveness: string = 'Liveness';
  public sanction: string = 'Sanction';

  public weekScheduleForPartner = 'Week Schedule';

  public riskGrade: string = 'Risk Grade';
  public riskGradeLevel: string = 'Level';
  public riskGradeSeverity: string = 'Severity';
  public riskGradeThreshold: string = 'Threshold (%)';
  public riskGradeHoldTransaction: string = 'Hold Transaction';
  public riskGradePauseAccount: string = 'Pause Account';
  public riskGradeApprovalOptions: string = 'Approval Options';

  public iSar: string = 'I-SAR';
  public sarCreatedDate: string = 'Created Date';
  public sarTransactionCode: string = 'Transaction Code';
  public sarExplanation: string = 'Explanation';

  public updateSmtp: string = 'Update SMTP Configuration';
  public smtpServerHost: string = 'SMTP Server Host';
  public smtpServerPort: string = 'SMTP Server Port';
  public smtpUserName: string = 'SMTP User Name';
  public smtpPassword: string = 'SMTP Password';
  public smtpSenderEmail: string = 'SMTP Sender Email';
  public smtpAuthEnabled: string = 'SMTP Auth Enabled';
  public smtpSSLEnabled: string = 'SMTP SSL Enabled';
  public smtpStartTlsEnabled: string = 'SMTP Start TLS Enabled';

  public receiverProfileType: string = 'Receiver Profile Type';

  public paymentMethod: string = 'Payment Method';
  public payoutMethod: string = 'Payout Method';
}
